// O PRIMEIRO CONTATO: o que é este jogo, em quinze segundos.
//
// Quem chega por um link não sabe nada — nem que é de basquete, nem que é de
// treinador, nem que dá para jogar sem pagar. A home responde isso, mas só
// para quem lê a home inteira; a maioria decide antes.
//
// Regras que este modal segue:
//
//   aparece UMA vez      quem já viu não vê de novo, nem em outra carreira
//   nunca por cima do jogo   só na tela inicial, e só para quem não tem carreira
//   uma ação principal   "Começar carreira" -- o resto é secundário
//
// ⚠️ Não é lugar de vender. O que abre o Pix é a NBA, e isso está no card do
// premium logo abaixo na home. Um modal de entrada que já pede dinheiro faz a
// pessoa fechar tudo -- e ela ainda não sabe se gosta do jogo.

import React, { useEffect } from 'react';
import { Ball } from './logo.jsx';

const VISTO_KEY = 'basquete82.boasVindas';

export function jaViuBoasVindas() {
  try { return localStorage.getItem(VISTO_KEY) === 'sim'; } catch { return true; }
}

export function marcarBoasVindas() {
  try { localStorage.setItem(VISTO_KEY, 'sim'); } catch { /* armazenamento bloqueado */ }
}

const PASSOS = [
  ['🏀', 'Você é o treinador', 'Escolhe quem joga, a rotação e a tática — e comanda a partida quarto a quarto.'],
  ['💱', 'O mercado é vivo', 'Clubes fazem propostas pelos seus atletas. Você vende, compra, negocia e monta o elenco.'],
  ['🎲', 'Draft com loteria', 'Na NBA, as quatro primeiras escolhas são sorteadas — quem foi pior tem mais chance, como na vida real. Você escolhe entre os calouros e aposta em quem ainda vai crescer.'],
  ['📅', 'Temporada inteira', '34 rodadas, playoffs e entressafra. A carreira segue ano após ano, de 2026 em diante.'],
  ['🏆', 'A diretoria cobra', 'Tem meta a bater. Entregou, a reputação sobe; não entregou, você é demitido e procura outro clube.'],
];

export function BoasVindas({ onComecar, onFechar }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onFechar(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onFechar]);

  return (
    <div className="backdrop" onClick={(e) => { if (e.target === e.currentTarget) onFechar(); }}>
      <div className="modal bem-vindo">
        <div className="bv-topo">
          <Ball size={54} />
          <p className="kicker" style={{ marginTop: 8 }}>• Modo treinador</p>
          <h1 className="bv-titulo">82 <b>Basquete</b></h1>
          <p className="bv-lead">
            Um jogo de carreira: você assume um clube de basquete e leva ele por
            quantas temporadas aguentar.
          </p>
        </div>

        <div className="bv-passos">
          {PASSOS.map(([ic, titulo, texto]) => (
            <div key={titulo} className="bv-passo">
              <span className="ic">{ic}</span>
              <div>
                <div className="t">{titulo}</div>
                <div className="d">{texto}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="bv-gratis">
          <b>O NBB é grátis e completo</b> — 18 clubes com elencos reais, sem
          conta, sem anúncio no meio do jogo. A NBA abre com um pagamento único,
          quando você quiser.
        </div>

        <button className="primary bv-cta" onClick={onComecar}>
          Começar minha carreira
        </button>
        <button className="ghost sm bv-depois" onClick={onFechar}>
          só quero olhar
        </button>
      </div>
    </div>
  );
}
